export enum ActionTypes {
  GET_ALL_COUNTRIES = 'GET_ALL_COUNTRIES',
  GET_COUNTRIES_BY_NAME = 'GET_COUNTRIES_BY_NAME',
  GET_COUNTRIES_BY_ID = 'GET_COUNTRIES_BY_ID',
  CREATE_ACTIVITY = 'CREATE_ACTIVITY',
  GET_ALL_ACTIVITIES = 'GET_ALL_ACTIVITIES',
  UPDATE_ACTIVITY = 'UPDATE_ACTIVITY',
  DELETE_ACTIVITY = 'DELETE_ACTIVITY',
  ORDER_BY_NAME = 'ORDER_BY_NAME',
  ORDER_BY_POPULATION = 'ORDER_BY_POPULATION',
  FILTER_BY_CONTINENTS = 'FILTER_BY_CONTINENTS',
  FILTER_BY_ACTIVITIES = 'FILTER_BY_ACTIVITIES',
}

export enum BACK {
  countries = '/countries',
  activities = '/activities',
}

export enum F_O {
  ALL = 'ALL',
  ASC = 'ASC',
  DESC = 'DESC',
  Mayor_Poblacion = "Mayor_Poblacion",
  Menor_Poblacion = "Menor_Poblacion",
}